package com.essntl.features.paymentparameter.data.repository

import com.essntl.core.supabase.*
import com.essntl.core.utils.repository.Repository
import com.essntl.features.paymentparameter.data.supabase.PaymentParameterSupabaseDataSource
import com.essntl.features.paymentparameter.data.supabase.toRequestMap
import com.essntl.features.paymentparameter.domain.model.PaymentParameterModel
import com.essntl.features.paymentparameter.domain.repository.PaymentParameterRepository
import org.koin.core.annotation.Single

@Single(binds = [PaymentParameterRepository::class])
internal class PaymentParameterRepositoryImpl internal constructor(
    private val supabase: PaymentParameterSupabaseDataSource,
) : Repository(), PaymentParameterRepository {
    override suspend fun getAll(): Result<List<PaymentParameterModel>> =
        runCatching {
            supabase
                .getAll()
                .map { it.toModel() }
        }

    override suspend fun getById(id: String): Result<PaymentParameterModel> =
        runCatching {
            supabase
                .getById(id = id)
                .toModel()
        }

    override suspend fun insert(paymentParameter: PaymentParameterModel): Result<PaymentParameterModel> =
        runCatching {
            supabase
                .insert(paymentParameter.copy(isInvoice = paymentParameter.isInvoice ?: false).toRequestMap())
                .toModel()
        }

    override suspend fun update(paymentParameter: PaymentParameterModel): Result<PaymentParameterModel> =
        runCatching {
            supabase
                .update(
                    id = paymentParameter.id,
                    requestMap = paymentParameter.toRequestMap(),
                ).toModel()
        }

    override suspend fun delete(paymentParameter: PaymentParameterModel): Result<Unit> =
        runCatching {
            supabase.delete(id = paymentParameter.id)
        }
}
